import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import {commercialHoursInInterval} from "../../../common/Util";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
    chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false
    },

    title: {
        text: 'Total de horas em ciclo'
    },

    pane: {
        startAngle: -150,
        endAngle: 150,
        background: [{
            backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                    [0, '#FFF'],
                    [1, '#333']
                ]
            },
            borderWidth: 0,
            outerRadius: '109%'
        }, {
            backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                    [0, '#333'],
                    [1, '#FFF']
                ]
            },
            borderWidth: 1,
            outerRadius: '107%'
        }, {
            // default background
        }, {
            backgroundColor: '#DDD',
            borderWidth: 0,
            outerRadius: '105%',
            innerRadius: '103%'
        }]
    },

    // the value axis
    yAxis: {
        min: 0,
        max: 400,

        minorTickInterval: 'auto',
        minorTickWidth: 1,
        minorTickLength: 10,
        minorTickPosition: 'inside',
        minorTickColor: '#666',

        tickPixelInterval: 30,
        tickWidth: 2,
        tickPosition: 'inside',
        tickLength: 10,
        tickColor: '#666',
        labels: {
            step: 2,
            rotation: 'auto'
        },
        title: {
            text: 'horas'
        },

    },

    series: [{
        name: 'Horas utilizadas',
        data: [],
        tooltip: {
            valueSuffix: ' horas'
        }
    }]

};

export default function HourTotalChart(prop) {
    const { series, filter } = prop;
    if (series) {
        let categories = [];
        let perioddata = [];

        series.map(i => {
            //categories.push(i.data.substring(0, 10));
            perioddata.push(Math.round(i.TotalTempoCiclo / 60 / 60 * 10) / 10);
        })

        let cH = commercialHoursInInterval(filter.periodMin, filter.periodMax);

        config = {
            ...config,
            title: {
                text: 'Horas em ciclo no periodo'
            },

            series: [
                {
                    name: 'Total ' ,
                    data: perioddata
                },
            ],
            yAxis: {
                ...config.yAxis,
                min: 0,
                max: cH,
                plotBands: [{
                        from: 0,
                        to: Math.round( cH * 0.4),
                        color: '#DF5353' // red
                    }, {
                        from: Math.round( cH * 0.4),
                        to:  Math.round( cH * 0.8 ),
                        color: '#DDDF0D' // yellow
                    }, {
                        from: Math.round( cH * 0.8),
                        to: cH,
                        color: '#55BF3B' // green
                    }]
            }
        }

    }


    return (
        <Card title="laos">
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
